import { Editor, track } from '@tldraw/tldraw'
import { ButtonGroup } from './ButtonGroup'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { FlipLeft, FlipRight } from 'blaze-ui/icons'
import { useActions } from '../VisualEditor/hooks/useActions'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  editor: Editor
}

export const HistoryButtonGroup = track(({ editor }: Props) => {
  const actions = useActions(editor)
  const isSystemRedesignEnabled = useIsSystemRedesign()

  if (isSystemRedesignEnabled) {
    return (
      <ButtonGroup>
        <IconButton
          aria-label="Undo"
          icon={() => <FlipLeft size={18} />}
          onPress={() => actions['undo'].onSelect()}
          isDisabled={!editor.getCanUndo()}
          size="sm"
          variant="tertiary"
        />
        <IconButton
          aria-label="Redo"
          icon={() => <FlipRight size={18} />}
          onPress={() => actions['redo'].onSelect()}
          isDisabled={!editor.getCanRedo()}
          size="sm"
          variant="tertiary"
        />
      </ButtonGroup>
    )
  }

  return (
    <ButtonGroup>
      <Button
        aria-label="Undo"
        icon={() => <FlipLeft size={isSystemRedesignEnabled ? 18 : 20} />}
        onPress={() => actions['undo'].onSelect()}
        isDisabled={!editor.getCanUndo()}
      />
      <Button
        aria-label="Redo"
        icon={() => <FlipRight size={isSystemRedesignEnabled ? 18 : 20} />}
        onPress={() => actions['redo'].onSelect()}
        isDisabled={!editor.getCanRedo()}
      />
    </ButtonGroup>
  )
})
